import axios from "axios";

export default axios.create({
  baseURL: "https://zaunmap.pages.dev/file",
});